<template>
  <div class="loading-page">
    <AntResult
      v-if="getStatus === EAntResultStatus.INFO"
      title="Идет процесс аутентификации"
      sub-title="Нужно немного подождать"
      :status="getStatus"
    >
      <template #icon>
        <AntIcon :url="EAntIconUrl.LOADING_OUTLINED" />
      </template>
    </AntResult>

    <AntResult
      v-else-if="getStatus === EAntResultStatus.ERROR"
      title="Ошибка системы при авторизации"
      sub-title="Обратитесь к администратору для решения проблемы"
      :status="getStatus"
    />
  </div>
</template>

<script lang="ts">
export default {};
</script>

<script setup lang="ts">
import {computed} from 'vue';

import {EAntIconUrl} from '@/assets/ant/icon/enums';
import {EAntResultStatus} from '@/assets/ant/result/enums';

import {keycloakAPI} from '@/assets/keycloak';

import AntIcon from '@/assets/ant/icon/AntIcon.vue';
import AntResult from '@/assets/ant/result/AntResult.vue';

const getStatus = computed(() => {
  if (keycloakAPI.getIsInit.value) return EAntResultStatus.SUCCESS;
  else if (keycloakAPI.getIsInitError.value) return EAntResultStatus.ERROR;
  else return EAntResultStatus.INFO;
});
</script>

<style lang="scss">
.loading-page {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
